import React from 'react';
import './video-blog.scss';
import { useNavigate } from 'react-router-dom';
import { videoBlogContent } from '../../Helper/Text-Blogs';

const VideoBlog = () => {
  const navigate = useNavigate();
  const videoContent = videoBlogContent;

  const videoConetnt = videoContent.map((item, index) => {
    return (
      <div
        key={index}
        className='video-responsives yt-iframe'
        // style={{background:'https://i.ytimg.com/vi/'+item.blogthumbnail+"/hq720.jpg"}}
        style={{
          backgroundImage: `url('https://i.ytimg.com/vi/${item.blogthumbnail}/hq720.jpg')`,
        }}
        onClick={() => {
          navigate(`/blogs/video/${item.blogthumbnail}`);
        }}
      >
        <iframe
          id='ytplayer'
          className='iframe'
          width='100%'
          height='360'
          title='video'
          src={`https://www.youtube.com/embed/${item.blogthumbnail}?&autoplay=1' frameborder='0' allow='autoplay;' allowfullscreen`}
          frameBorder='0'
          style={{ pointerEvents: 'none' }}
        ></iframe>
      </div>
    );
  });

  return <>{videoConetnt}</>;
};

export default VideoBlog;
